<script type="text/jsx">
export default {
  functional: true,
  props: {
    whboTotal: {},
    showSimbols: {}
  },
  render (h, context) {
    const { props } = context
    const { whboTotal, showSimbols } = props

    const final = []

    if (showSimbols) {
      whboTotal.titleList.forEach((line, index) => {
        // TODO fix this mess...
        if (index === 0) {
          final.push(
            <div class="flexy-item-total">
              <div class="line" title={whboTotal.titles[line].hover} style="text-align: center">
                <div class="box-title lowercase">{whboTotal.titles[line].text}</div>
                <div class="box success">{whboTotal[line]}</div>
              </div>
            </div>
          )
          final.push(
            <div class="flexy-item-symbol">
              <div class="line">
                <div class="box">-</div>
              </div>
            </div>
          )
        } else if (index === 1) {
          final.push(
            <div class="flexy-item-total">
              <div class="line" title={whboTotal.titles[line].hover} style="text-align: center">
                <div class="box-title lowercase">{whboTotal.titles[line].text}</div>
                <div class="box danger">{whboTotal[line]}</div>
              </div>
            </div>
          )
          final.push(
            <div class="flexy-item-symbol">
              <div class="line">
                <div class="box">=</div>
              </div>
            </div>
          )
        } else {
          final.push(
            <div class="flexy-item-total">
              <div class="line" title={whboTotal.titles[line].hover} style="text-align: center">
                <div class="box-title lowercase">{whboTotal.titles[line].text}</div>
                <div class={parseInt(whboTotal[line]) > 0 ? 'box success' : 'box danger'}>{whboTotal[line]}</div>
              </div>
            </div>
          )
        }
      })
    } else {
      whboTotal.titleList.forEach((line, index) => {
        final.push(
          <div class="flexy-item">
            <div class="line" title={whboTotal.titles[line].hover} style="text-align: center">
              <div class="box-title lowercase">{whboTotal.titles[line].text}</div>
              <div class="box default">{whboTotal[line]}</div>
            </div>
          </div>
        )
      })
    }

    return (
      <div class={showSimbols ? 'flexy-container-total' : 'flexy-container'}>
        {final}
      </div>
    )
  }
}
</script>

<style scoped>
.flexy-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-end;
  align-content: space-around;
}
.flexy-container-total {
  display: flex;
  justify-content: center;
  align-items: flex-end;
  /* align-content: space-around; */
}
.flexy-item {
  /* flex: 0 1 auto; */
  width: 50%;
}
.flexy-item-total {
  /* flex: 0 1 auto; */
  width: 20%;
}
.flexy-item-symbol {
  /* flex: 0 1 auto; */
  width: 7%;
  font-weight: bold;
  font-size: 20px;
}
.box {
  font-size: 11px !important;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 3px 5px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
}
.box-title {
  font-size: 11px;
}
.line {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px;
}
.line .box {
  width: 60%;
}
.flexy-item-total .box {
  width: 80%;
}
.default {
  border: 2px solid var(--color-default);
}
.warning {
  border: 2px solid var(--color-warning);
}
.info {
  border: 2px solid var(--color-info);
}
.success {
  background-color: var(--color-success);
  border: 2px solid var(--color-success);
  color: white;
}
.danger {
  background-color: var(--color-danger);
  border: 2px solid var(--color-danger);
  color: white;
}
</style>
